import { NORMALIZED_PATTERN, NORMALIZED_MIN_PATTERN_DASHED, getDiffDates, dateInMilliseconds } from '@/utils/date';
import { DATE_TIME } from '@/utils/constants';
import { FILTER_NAMES } from '@/store/modules/cards/constants';

const validPublicPostFilters = [
  'names',
  'themes',
  'tags',
  'polarities',
  'dark_post',
  'channels_listening',
  'uids',
];
const validProprietaryFilters = [
  'themes',
  'tags',
  'polarities',
  'dark_post',
  'uids',
  'pages',
  'channels',
  'sac_type',
  'sac_status',
  'sac_replier',
];
const validPageMetricsFilters = [
  'pages',
  'channels',
];
const validSacStatusFilters = [
  'pages',
  'channels',
  'sac_type',
  'sac_last_status',
  'sac_status',
  'sac_replier',
];
const validCompetitiveFilters = [
  'names',
  'channels_listening',
];
const validSacListeningFilters = [
  FILTER_NAMES.GROUP,
  FILTER_NAMES.THEME,
  FILTER_NAMES.TAG,
  FILTER_NAMES.DARK_POST,
  FILTER_NAMES.FAVORITE,
  FILTER_NAMES.PAGES,
  FILTER_NAMES.CHANNEL,
  FILTER_NAMES.SAC_TYPE,
  FILTER_NAMES.UIDS,
  FILTER_NAMES.CHANNELS_LISTENING,
];

const validBlipFilters = [
  FILTER_NAMES.CONTRACTS,
  FILTER_NAMES.BOTS,
  FILTER_NAMES.CATEGORY,
];

const getValidFilters = (filters, validFiltersKeys) => {
  const validFilters = {};

  Object.keys(filters)
    .filter((filter) => validFiltersKeys.includes(filter))
    .forEach((filter) => {
      validFilters[filter] = filters[filter];
    });

  return validFilters;
};

const channelsMapper = (filter) => {
  filter.channels = filter.channels_listening;
  delete filter.channels_listening;
  return filter;
};

const entireEndDateInMillisec = 86340000;

export default {
  formattedDateRange: (state) => `${state.dateRange.start.format(NORMALIZED_PATTERN)}:${state.dateRange.end.format(NORMALIZED_PATTERN)}`,
  getStarDashedDate: (state) => `${state.dateRange.start.format(NORMALIZED_MIN_PATTERN_DASHED)}`,
  getEndDashedDate: (state) => `${state.dateRange.end.format(NORMALIZED_MIN_PATTERN_DASHED)}`,
  getEndDate: (state) => `${state.dateRange.end.format(NORMALIZED_PATTERN)}`,
  getDiffDatesInMinutes: (state) => getDiffDates(state.dateRange.start, state.dateRange.end, DATE_TIME.MINUTES),
  getStartDateInMilliseconds: (state) => Number(dateInMilliseconds(state.dateRange.start.format(NORMALIZED_PATTERN))),
  getEndDateInMilliseconds: (state) => Number(dateInMilliseconds(state.dateRange.end.format(NORMALIZED_PATTERN))) + entireEndDateInMillisec,
  publicPostFilter: (state) => {
    const filter = getValidFilters(state.globalFilter, validPublicPostFilters);

    if ('channels_listening' in filter) {
      return channelsMapper(filter);
    }

    return filter;
  },
  proprietaryFilter: (state) => getValidFilters(state.globalFilter, validProprietaryFilters),
  pageMetricsFilter: (state) => getValidFilters(state.globalFilter, validPageMetricsFilters),
  sacStatusFilter: (state) => getValidFilters(state.globalFilter, validSacStatusFilters),
  competitiveFilter: (state) => {
    const filter = getValidFilters(state.globalFilter, validCompetitiveFilters);

    if ('channels_listening' in filter) {
      return channelsMapper(filter);
    }

    return filter;
  },
  blipFilter: (state) => getValidFilters(state.globalFilter, validBlipFilters),
  sacListeningFilter: (state) => {
    const filter = getValidFilters(state.globalFilter, validSacListeningFilters);

    if ('channels_listening' in filter) {
      return channelsMapper(filter);
    }
    return filter;
  },

  filterByDataType: (state, getters) => {
    const globalFilterByDataType = {
      listening: { ...getters.publicPostFilter },
      sac: { ...getters.proprietaryFilter },
      page: { ...getters.pageMetricsFilter },
      static: undefined,
      competitive: { ...getters.competitiveFilter },
      'sac-status': { ...getters.sacStatusFilter },
      'sac-listening': { ...getters.sacListeningFilter },
      blip: { ...getters.blipFilter },
    };

    return globalFilterByDataType;
  },
};
